// extracted by mini-css-extract-plugin
module.exports = {"content":"ApplicationContent__content___1RG2h","heading":"ApplicationContent__heading___3Xe7E"};